import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListSubBrandsRequest, ListSubBrandsResponse } from "../contracts";
import { baseQueryWithAuth } from "./api";

export const subBrandApi = createApi({
    reducerPath: "subBrandApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        listSubBrands: builder.query<ListSubBrandsResponse, ListSubBrandsRequest>({
            query: body => ({
                url: "subbrand/list",
                method: "POST",
                body
            })
        })
    })
});

export const { useListSubBrandsQuery } = subBrandApi;
